// extracted by mini-css-extract-plugin
module.exports = {"text":"wJzg6","quote-wrapper":"_2-fYj","attribution":"_2RfJk"};